export default __webpack_public_path__ + "static/based-cdn-demo-4a11aa717d52d68419d89e56fb24fff9.mp4";